import { Flex, useTheme } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isMobileView } from 'constants/isMobileView';

const FooterSection = ({ onSave, onCancel, isSaveDisabled }) => {
  const theme = useTheme();
  return (
    <Flex
      bgColor={theme.colors.surface.F5F7F9}
      alignItems="center"
      justifyContent="space-between"
      // eslint-disable-next-line no-nested-ternary
      width={checkNewNavEnabled() ? '100%' : isMobileView() ? '100%' : 'calc(100vw - 250px)'}
      columnGap={4}
    >
      <Button onClick={() => onCancel(true)} variant="outline" disabled={false}>
        Cancel
      </Button>

      <Button onClick={onSave} disabled={isSaveDisabled}>
        Save
      </Button>
    </Flex>
  );
};

export default FooterSection;
